import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import ListFormTemplate from "../../PageTemplate/ListFormTemplate";
import { countries, timezones } from "../../../utils/config";
import axios from "axios";
import { config } from "../../../utils/config";

import "./style.css";
import { fetchDataAndMapToField } from "../../../utils/helperFuctions";
import useBranchLogic from "./useBranchLogic";

const columns = [
  { field: "id", label: "ID", allowSorting: false, decimalCount: 0 },
  { field: "Name", label: "Name", allowSorting: true },
  {
    field: "country",
    label: "Country",
    allowSorting: true,
    subvalue: "name",
    showInFilter: true,
  },
  {
    field: "currency",
    label: "Currency",
    allowSorting: false,
    subvalue: "code",
  },
];

const BranchPage = () => {
  const { addRoles, deleteRoles, editRoles, apiRoute, initFields } =
    useBranchLogic();
  const [fields, setfields] = useState(initFields);

  const loadOptions = async (branchId) => {
    try {
      // Replace with your API endpoint to fetch the data

      const temp = [...initFields];

      //API endpoint to fetch the data
      // Call the function for each API endpoint
      //await fetchDataAndMapToField(config, 'currencies', 'currencies', temp,'code');
      await fetchDataAndMapToField(
        config,
        "currencies",
        "currency",
        temp,
        "code"
      );
      await fetchDataAndMapToField(config, "cities/countries", "country", temp);
      setfields(temp);
    } catch (error) {
      console.error("Error fetching data:", error);
      return [];
    }
  };

  return (
    <div>
      <Helmet>
        <title>Admin | Glide</title>
        <meta name="description" content="Welcome to the Branches." />
        {/* Other meta tags */}
      </Helmet>
      <ListFormTemplate
        tableNameInDb={"branch"}
        apiRoute={apiRoute}
        columns={columns}
        fields={fields}
        bringFormData={loadOptions}
        createRoles={addRoles}
        deleteRoles={deleteRoles}
        editRoles={editRoles}
      />
    </div>
  );
};

export default BranchPage;
